// extracted by mini-css-extract-plugin
export default {"btn":"Counter-module__btn--oyrL_","counter":"Counter-module__counter--xloHl","text":"Counter-module__text--BiLNb","counterIcon":"Counter-module__counterIcon--_WtRw"};